import { playerCurrentTeamFragment, playerFullStatsFragment } from '../Players/player.fragments'
import {
  fullStatsFragment,
  statLeadersFragment,
  basicCoachesFragment,
  basicTeamInfoFragment,
} from './team.fragments'

export const standingsQuery = `
query($year: Int!, $champSeries: Boolean!) {
  standings(season: $year, champSeries: $champSeries){
    team{
      officialId
      location
      locationCode
      urlLogo
      fullName
    }
    seed
    wins @skip(if: $champSeries)
    losses @skip(if: $champSeries)
    ties @skip(if: $champSeries)
    scores @skip(if: $champSeries)
    scoresAgainst @skip(if: $champSeries)
    scoreDiff @skip(if: $champSeries)
    csWins @include(if: $champSeries)
    csLosses @include(if: $champSeries)
    csTies @include(if: $champSeries)
    csScores @include(if: $champSeries)
    csScoresAgainst @include(if: $champSeries)
    csScoreDiff @include(if: $champSeries)
    conferenceWins
    conferenceLosses
    conferenceTies
    conferenceScores
    conferenceScoresAgainst
    conference
    conferenceSeed
  }
}
`

//FETCH WITH CHAMP SERIES INFO
export const teamAllDataQuery = `
query($id: ID!, $year: Int, $statsYear: Int, $eventsYear: Int, $statList: [String], $includeCS: Boolean!) {
  team(id:$id,  forYear: $year) {
		officialId
    teamLogo: urlLogo
    fullName
    league
    slogan
    teamLosses
    teamLossesPost
    teamTies
    teamTiesPost
    teamWins
    teamWinsPost
    location
    locationCode
    coaches{
     ...BasicCoachesFragment
    }
    events(year: $eventsYear) {
      id
      slugname
      externalId
      startTime
      week
      venue
      description
      location
      broadcaster
      eventStatus
      period
      homeScore
      visitorScore
      urlTicket
      urlPreview
      urlStreaming
      gameStatus
      seasonSegment
      year
      waitlist
      waitlistUrl
      suiteId
      weekendTicketId
      awayTeam {
        ...BasicTeamInfoFragment
      }
      homeTeam {
        ...BasicTeamInfoFragment
      }
    }
    champSeries(year: $year) @include(if: $includeCS) {
      teamWins
      teamLosses
      teamTies
      roster {
        officialId
        slug
        profileUrl
        firstName
        lastName
        height
        age
        college
        collegeYear
        injuryStatus
        injuryDescription
        jerseyNum
        champSeries(year: $year) {
          year
          position
          positionName
        }
      }
      events {
        id
        slugname
        externalId
        startTime
        week
        venue
        description
        location
        broadcaster
        eventStatus
        period
        homeScore
        visitorScore
        urlTicket
        urlPreview
        urlStreaming
        gameStatus
        seasonSegment
        year
        waitlist
        waitlistUrl
        suiteId
        weekendTicketId
        awayTeam {
          ...BasicTeamInfoFragment
        }
        homeTeam {
          ...BasicTeamInfoFragment
        }
      }
      stats {
        ...FullTeamStatsFragment
      }
    }
    stats(year: $statsYear, segment: regular) {
      ...FullTeamStatsFragment
    }
    postStats: stats(year: $statsYear, segment: post) {
      ...FullTeamStatsFragment
    }
    statLeaders(statYear: $statsYear, seasonSegment: regular, statList: $statList) {
      ...StatLeadersFragment
    }
    csStatLeaders: statLeaders(statYear: $year, seasonSegment: champseries, statList: $statList) @include(if: $includeCS) {
      ...StatLeadersFragment
    }
  }
}
  ${basicTeamInfoFragment}
  ${fullStatsFragment}
  ${statLeadersFragment}
  ${basicCoachesFragment}
`

export const teamMatchupsDataQuery = `
query($id: ID!, $year: Int, $segment: StatSegment!, $statsYear: Int, $isChampSeries: Boolean!) {
  team(id:$id, forYear: $year) {
		officialId
    teamColor
    teamLogo:urlLogo  
    fullName
    teamWins
    teamWinsPost
    teamLosses
    teamLossesPost
    teamTies
    teamTiesPost
    location
    locationCode
    stats (year: $statsYear, segment:$segment)  @skip(if: $isChampSeries) {
      gamesPlayed
      scores
      shotPct
      onePointGoals
      twoPointGoals
      turnovers
      faceoffPct
      savePct
      scoresPG
      saa
      shotsPG
    }
    players @skip(if: $isChampSeries) {
      positionName
      officialId
      profileUrl
      jerseyNum
      firstName
      lastName
      lastNameSuffix
      position
      height
      weight
      age
      country
      countryCode
      college
      collegeYear
      injuryStatus
      injuryDescription
      slug
      rosterStatus
			currentTeam {
        ...PlayerCurrentTeamFragment
      }
      stats(year: $statsYear, segment: $segment) {
        points
        faceoffPct
        shotPct
        savePct
        shotsOnGoalPct
        onePointGoals
        twoPointGoals
        scoresAgainst
        saa
        gamesPlayed
        goals
        assists
        groundBalls
        turnovers
        causedTurnovers
        faceoffsWon
        faceoffsLost
        faceoffs
        shots
        goalsAgainst
        twoPointGoalsAgainst
        saves
      }
    }
    champSeries(year: $year) @include(if: $isChampSeries) {
      teamWins
      teamLosses
      teamTies
      stats{
        gamesPlayed
        scores
        shotPct
        onePointGoals
        twoPointGoals
        turnovers
        faceoffPct
        savePct
        scoresPG
        saa
        shotsPG
      }
      roster {
        officialId
        slug
        profileUrl
        firstName
        lastName
        height
        age
        college
        collegeYear
        injuryStatus
        injuryDescription
        jerseyNum
        champSeries(year: $year) {
          year
          position
          positionName
          stats {
            ...PlayerFullStatsFragment
          }
        }
      }
    }
  }
}
${playerCurrentTeamFragment}
${playerFullStatsFragment}
`

export const allGamedayRostersQuery = `
query($year: Int!, $week: Int!){
  allGamedayRosters(year: $year, week: $week) {
    officialId
    slug
    fullName
    location
    locationCode
    teamLogo: urlLogo
    gamedayRoster(year: $year, week: $week) {
      officialId
      slug
      year
      profileUrl
      firstName
      lastName
      position
      jerseyNum
      injuryStatus
      injuryDescription
      height
      age
      college
      collegeYear
      rosterStatus
    }
  }
}`
